import React, { FC, useEffect, useState } from 'react';
import { useWindowSize } from '../../../../../../hooks/useWindowSize';
import ControlBar, { ValuesType } from '../controlBar/controlBar.component';
import GridItem from '../../../../../layout/GridComponents/GridItem';
import GeneralCard from '../../../../../general/GeneralCard';
import HistoricalDataView from '../data-view/data-view.component';
import type { HistoricalDataPayload } from '../../../../../../api/rs-hg/risk/historicalData.types';

export interface DataContainerProps {
  topLevel: ValuesType;
  onTopLevelChange?: (values: ValuesType) => void;
  fourShowing: boolean;
  itemIdentifier: number;
  activeFund: string | undefined;
  data: HistoricalDataPayload;
  fixedTitle?: 'Table' | 'Time Series';
  external: boolean;
}

const DataContainer: FC<DataContainerProps> = ({
  topLevel,
  onTopLevelChange,
  fourShowing,
  itemIdentifier,
  activeFund,
  data,
  ...props
}) => {
  const [showTable, setShowTable] = useState(true);
  const { height, width } = useWindowSize();

  const AddControl = fourShowing ? (
    <ControlBar
      displaySelect={false}
      showFour={fourShowing}
      showTable={showTable}
      setShowTable={setShowTable}
      fundId={activeFund || 'none_selected'}
      values={topLevel}
      handleChoice={onTopLevelChange ?? (() => undefined)}
    />
  ) : null;

  const adjustedHeight = fourShowing ? (height - 276) / 2 : height - 204;

  return (
    <GridItem
      xs={fourShowing ? 6 : 12}
      lg={
        props.fixedTitle
          ? props.fixedTitle === 'Time Series'
            ? 8
            : 4
          : 6
      }
      style={{
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'center',
      }}
    >
      {AddControl}
      <GeneralCard cardStyle={{ height: '100%' }}>
        <HistoricalDataView
          external={props.external}
          dimensions={{ height, width }}
          adjustedHeight={adjustedHeight}
          fourShowing={fourShowing}
          data={data}
          showTable={
            props.fixedTitle ? props.fixedTitle !== 'Table' : showTable
          }
          keysAndDates={topLevel}
        />
      </GeneralCard>
    </GridItem>
  );
};

export default React.memo(DataContainer);
